import { useCallback, useEffect, useRef } from 'react'

type Params = {
  callback: (args: any) => void | Promise<void>
  delay?: number
}

export function useTimeout({ callback, delay = 5000 }: Params) {
  const callbackRef = useRef<any>(callback)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  useEffect(() => {
    callbackRef.current = callback
  }, [callback])
  const set = useCallback(() => {
    timeoutRef.current = setTimeout(() => callbackRef.current(), delay)
  }, [delay])
  const clear = useCallback(() => {
    timeoutRef.current && clearTimeout(timeoutRef.current)
  }, [])
  useEffect(() => {
    set()
    return clear
  }, [delay, set, clear])
  const reset = useCallback(() => {
    clear()
    set()
  }, [clear, set])
  return { reset, clear }
}
